/* ── Waco Diamonds — PDP deep-link reader ─────────────────────────────────────────────────
   When a shopper reaches a combined-listing ring PDP from a collection card that had a price
   configuration applied, the URL carries `#waco-config=<karat>|<carat>|<quality>`. Preselect
   those three options in the Waco variant picker so the PDP opens showing the same price the
   card showed. No-op when the hash is absent or already matches. Presentation-only. */
(function () {
  "use strict";
  if (window.__wacoDeeplink) return;
  window.__wacoDeeplink = true;

  function parse() {
    var hash = window.location.hash || "";
    var cfg = {};
    var mc = hash.match(/waco-config=([^&#]+)/); // karat|carat|quality (from collection price control)
    if (mc) {
      try {
        var parts = decodeURIComponent(mc[1]).split("|");
        if (parts.length === 3) {
          cfg["Metal Karat"] = parts[0];
          cfg["Carat Size"] = parts[1];
          cfg["Diamond Quality"] = parts[2];
        }
      } catch (e) { /* ignore */ }
    }
    var col = hash.match(/waco-color=([^&#]+)/); // Metal Color (from child→parent redirect)
    if (col) {
      try { cfg["Metal Color"] = decodeURIComponent(col[1]); } catch (e) { /* ignore */ }
    }
    return Object.keys(cfg).length ? cfg : null;
  }

  function q(sel, root) {
    return (root || document).querySelector(sel);
  }

  function apply(cfg) {
    var picker = q(".waco-variant-picker");
    if (!picker) return false;
    var changed = null;
    Object.keys(cfg).forEach(function (name) {
      var val = cfg[name];
      var group = picker.querySelectorAll('input.waco-radio[data-option-name="' + name + '"]');
      if (!group.length) return;
      var target = null;
      for (var i = 0; i < group.length; i++) {
        if (group[i].value === val) { target = group[i]; break; }
      }
      if (!target || target.classList.contains("disabled")) return;
      if (target.checked) return;
      for (var j = 0; j < group.length; j++) group[j].checked = false;
      target.checked = true;
      changed = target;
    });
    if (changed) {
      // One dispatch resolves the variant across all checked radios.
      changed.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }
    return false;
  }

  function run() {
    var cfg = parse();
    if (!cfg) return;
    // Try now, then a couple of animation frames later in case the picker is still enhancing.
    if (apply(cfg)) return;
    var tries = 0;
    (function retry() {
      if (tries++ > 8) return;
      if (apply(cfg)) return;
      requestAnimationFrame(retry);
    })();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
